export { default } from './PaginatedRecommendations';